module.exports = __webpack_public_path__ + "static/media/cq_corsivo.78ddf987.svg";